module.exports = __webpack_public_path__ + "static/media/pic2_tw.c7b0bd39.png";